import { api_get, PROYECT } from "services/api"

export const getCustomersCoincidences = async(search, idStation, setSnackbar) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/less_data`
  const getCustomersUrl = `${url}?filter=${search}&stations=${idStation}`
  return await api_get(getCustomersUrl)
    .then(customers => customers)
    .catch(err => {
      setSnackbar(err)
      return false
    })
}

export const getCustomersAccounts = async(id, setSnackbar) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}`
  return await api_get(url)
    .then(accounts => accounts)
    .catch(err => {
      setSnackbar(err)
      return false
    })
}